module.exports = __webpack_public_path__ + "img/programme6.ba670e89.png";